function Splash() {
  return null;
}

export default Splash;
